<template id="">
  <HomeDetail>
    <template #header-text>
      <div>
        <h2> {{current.header}} </h2>
        <div style="font-size: 16px; overflow: hidden; font-weight: 400" v-html="current.content"> </div>
      </div>

    </template>
    <template #navigation>
      <template v-if="widget === 'taktapp'">
      <div class="home-detail-button-list">
        <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktAppMain' ? 'color: #00fa00' : ''}`" @click="$router.push({ name: 'TaktAppMain'}) "> {{$t('Home.Home.TaktApp.Detail.Main.Button')}} </div>
        <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktAppOne' ? 'color: #00fa00' : ''}`" @click="$router.push({ name: 'TaktAppOne'})"> {{$t('Home.Home.TaktApp.Detail.One.Button')}} </div>
        <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktAppTwo' ? 'color: #00fa00' : ''}`" @click="$router.push({ name: 'TaktAppTwo'})"> {{$t('Home.Home.TaktApp.Detail.Two.Button')}} </div>
        <!-- <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktAppThree' ? 'color: #00fa00' : ''}`" @click="$router.push({ name: 'TaktAppThree'})"> TAKT.wallet </div> -->
        <!-- <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktAppFour' ? 'color: #00fa00' : ''}`" @click="$router.push({ name: 'TaktAppFour'})"> mobile </div> -->
        <!-- <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktAppFive' ? 'color: #00fa00' : ''}`" @click="$router.push({ name: 'TaktAppFive'}); toggleSidebar()"> WORK.bench </div> -->
        <!-- <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktAppSix' ? 'color: #00fa00' : ''}`" @click="$router.push({ name: 'TaktAppSix'})"> PRO.account </div> -->
      </div>
      </template>
      <template v-else-if="widget === 'takttraining'">
        <div class="home-detail-button-list">
        <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktTraining' ? 'color: #ff9300' : ''}`" @click="$router.push({ name: 'TaktTraining'})"> {{$t('Home.Home.TaktTraining.Detail.Main.Button')}} </div>
        <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktTraining' ? 'color: #ff9300' : ''}`" @click="$router.push({ name: 'TaktTraining'})"> {{$t('Home.Home.TaktTraining.Detail.One.Button')}} </div>
        <!-- <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktTraining' ? 'color: #ff9300' : ''}`" @click="$router.push({ name: 'TaktTraining'})"> TAKT.app for training </div> -->
        <!-- <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktTraining' ? 'color: green' : ''}`" @click="$router.push({ name: 'TaktTraining'}); toggleSidebar()"> Takt simulation </div> -->
        </div>
      </template>
      <template v-else-if="widget === 'algorithmicflow'">
        <div class="home-detail-button-list">
        <div class="home-detail-navigation-button" :style="`${$route.name === 'AlgorithmicFlowMain' ? 'color: #00fdff' : ''}`" @click="$router.push({ name: 'AlgorithmicFlowMain'})"> {{$t('Home.Home.AlgorithmicFlow.Detail.Main.Button')}} </div>
        <div class="home-detail-navigation-button" :style="`${$route.name === 'AlgorithmicFlowOne' ? 'color: #00fdff' : ''}`" @click="$router.push({ name: 'AlgorithmicFlowOne'})"> {{$t('Home.Home.AlgorithmicFlow.Detail.One.Button')}}</div>
        </div>
      </template>
      <template v-else-if="widget === 'poweroftakt'">
        <div class="home-detail-button-list">
        <!-- <div class="home-detail-navigation-button" :style="`${$route.name === 'PowerOfTaktMain' ? 'color: #fffc00' : ''}`" @click="$router.push({ name: 'PowerOfTaktMain'})"> Principles of takt </div> -->
        <div class="home-detail-navigation-button" :style="`${$route.name === 'PowerOfTaktOne' || $route.name === 'PowerOfTaktOneMobile' ? 'color: #fffc00' : ''}`" @click="$vuetify.breakpoint.smAndDown ? $router.push({ name: 'PowerOfTaktOneMobile'}) : $router.push({ name: 'PowerOfTaktOne'})">
        {{$t('Home.Home.PowerOfTakt.Detail.Main.Button')}} </div>
        <div class="home-detail-navigation-button" :style="`${$route.name === 'PowerOfTaktTwo' ? 'color: #fffc00' : ''}`" @click="$router.push({ name: 'PowerOfTaktTwo'})"> {{$t('Home.Home.PowerOfTakt.Detail.One.Button')}} </div>
        <div class="home-detail-navigation-button" :style="`${$route.name === 'PowerOfTaktThree' ? 'color: #fffc00' : ''}`" @click="$router.push({ name: 'PowerOfTaktThree'})"> {{$t('Home.Home.PowerOfTakt.Detail.Two.Button')}} </div>
        <!-- <div class="home-detail-navigation-button" :style="`${$route.name === 'PowerOfTaktFour' ? 'color: #fffc00' : ''}`" @click="$router.push({ name: 'PowerOfTaktFour'})"> Data and takt</div> -->
        </div>
      </template>
      <template v-else-if="widget === 'comingsoon'">
        <div class="home-detail-button-list">
        <div class="home-detail-navigation-button" :style="`${$route.name === 'ComingSoonMain' ? 'color: #921f92' : ''}`" @click="$router.push({ name: 'ComingSoonMain'})"> {{$t('Home.Home.ComingSoon.Detail.Main.Button')}} </div>
        <!-- <div class="home-detail-navigation-button" :style="`${$route.name === 'ComingSoonOne' ? 'color: #921f92' : ''}`" @click="$router.push({ name: 'ComingSoonOne'})"> {{$t('Home.Home.ComingSoon.Detail.One.Button')}} </div> -->
        <div class="home-detail-navigation-button" :style="`${$route.name === 'ComingSoonTwo' ? 'color: #921f92' : ''}`" @click="$router.push({ name: 'ComingSoonTwo'})"> {{$t('Home.Home.ComingSoon.Detail.Two.Button')}} </div>
        <div class="home-detail-navigation-button" :style="`${$route.name === 'ComingSoonThree' ? 'color: #921f92' : ''}`" @click="$router.push({ name: 'ComingSoonThree'})"> {{$t('Home.Home.ComingSoon.Detail.Three.Button')}} </div>
        </div>
      </template>
      <template v-else-if="widget === 'homeworkbench'">
        <div class="home-detail-button-list">
        <div class="home-detail-navigation-button" :style="`${$route.name === 'HomeWorkbenchMain' ? 'color: #ff9300' : ''}`" @click="$router.push({ name: 'HomeWorkbenchMain'}); "> {{$t('Home.Home.WorkBench.Detail.Main.Button')}} </div>
        <div class="home-detail-navigation-button" :style="`${$route.name === 'HomeWorkbenchOne' ? 'color: #ff9300' : ''}`" @click="$router.push({ name: 'HomeWorkbenchOne'}); toggleSidebar()"> {{$t('Home.Home.WorkBench.Detail.One.Button')}} </div>
        <div class="home-detail-navigation-button" :style="`${$route.name === 'HomeWorkbenchTwo' ? 'color: #ff9300' : ''}`" @click="$router.push({ name: 'HomeWorkbenchTwo'}); toggleSidebar()"> {{$t('Home.Home.WorkBench.Detail.Two.Button')}} </div>
        <!-- <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktTraining' ? 'color: green' : ''}`" @click="$router.push({ name: 'TaktTraining'}); toggleSidebar()"> Takt simulation </div> -->
        </div>
      </template>
      <template v-else-if="widget === 'taktpartners'">
        <div class="home-detail-button-list">
        <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktPartnersMain' ? 'color: #ff9300' : ''}`" @click="$router.push({ name: 'TaktPartnersMain'}); "> {{$t('Home.Home.TaktPartners.Detail.Main.Button')}} </div>
        <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktPartnersOne' ? 'color: #ff9300' : ''}`" @click="$router.push({ name: 'TaktPartnersOne'}); "> {{$t('Home.Home.TaktPartners.Detail.One.Button')}} </div>
        <!-- <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktPartnersTwo' ? 'color: #ff9300' : ''}`" @click="$router.push({ name: 'TaktPartnersTwo'}); "> TAKT.app for training </div> -->
        <!-- <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktTraining' ? 'color: green' : ''}`" @click="$router.push({ name: 'TaktTraining'}); toggleSidebar()"> Takt simulation </div> -->
        </div>
      </template>
      <template v-else-if="widget === 'taktconnection'">
        <div class="home-detail-button-list">
        <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktConnectionMain' ? 'color: #ff9300' : ''}`" @click="$router.push({ name: 'TaktConnectionMain'});"> {{$t('Home.Home.TaktConnect.Detail.Main.Button')}} </div>
        <!-- <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktConnectionOne' ? 'color: #ff9300' : ''}`" @click="$router.push({ name: 'TaktConnectionOne'}); toggleSidebar()"> TAKT.simulation </div> -->
        <!-- <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktConnectionTwo' ? 'color: #ff9300' : ''}`" @click="$router.push({ name: 'TaktConnectionTwo'}); toggleSidebar()"> TAKT.app for training </div> -->
        <!-- <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktTraining' ? 'color: green' : ''}`" @click="$router.push({ name: 'TaktTraining'}); toggleSidebar()"> Takt simulation </div> -->
        </div>
      </template>
      <template v-if="widget === 'taktcareer'">
      <div style="height: calc(100% - 200px); display: flex; flex-direction: column; justify-content: space-between">
        <div class="home-detail-button-list" :key="update_key_careers">
          <div 
            @click="$router.push({name: 'GeneralCareer'})"
            :style="`${$route.name === 'GeneralCareer' ? 'color: #00fa00' : ''}`"
          >
            General Information
          </div>
          <div
            v-for="(job, key) in $store.state.TaktNews.careers"
            :key="`job${job.id}${key}`"
            @click="$router.push({name: 'Career', params: {job_id: job.id}})"
            class="career-item"
            :style="`${job.id == $route.params.job_id ? 'color: #00fa00' : ''}`"
          >
            {{job.title}}
          </div>
          <!-- <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktCareerMain' ? 'color: #00fa00' : ''}`" @click="$router.push({ name: 'TaktCareerMain'}) "> {{$t('Home.Home.TaktCareer.Detail.Main.Button')}}  <small>(TH)</small></div>
          <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktCareerTwo' ? 'color: #00fa00' : ''}`" @click="$router.push({ name: 'TaktCareerTwo'})"> {{$t('Home.Home.TaktCareer.Detail.Two.Button')}} <small>(TH, IN)</small></div>
          <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktCareerThree' ? 'color: #00fa00' : ''}`" @click="$router.push({ name: 'TaktCareerThree'})"> {{$t('Home.Home.TaktCareer.Detail.Three.Button')}} <small>(TH, IN)</small></div>
          <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktCareerSix' ? 'color: #00fa00' : ''}`" @click="$router.push({ name: 'TaktCareerSix'})"> {{$t('Home.Home.TaktCareer.Detail.Six.Button')}} <small>(PE)</small></div> -->
        </div>
        <div
         style="display: flex; flex-direction: row; cursor: pointer">
          <div class="">
            Feel free to join our <a href="https://discord.gg/seycvEfdfJ" target="_blank" rel="noopener noreferrer">discord</a> and have a chat with us:
          </div>
          <img src="~@/assets/discord_qr.png" height="100px"/>
        </div>
        <!-- <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktCareerSix' ? 'color: #00fa00' : ''}`" @click="$router.push({ name: 'TaktCareerSix'})"> {{$t('Home.Home.TaktCareer.Detail.Six.Button')}} <small>(PE, WS, IN)</small></div> -->
      </div>
      </template>
      <template v-else-if="widget === 'takting'">
        <div class="home-detail-button-list">
        <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktingDescriptionMain' ? 'color: green' : ''}`" @click="$router.push({ name: 'TaktingDescriptionMain'})"> Who we are? </div>
        <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktingDescriptionOne' ? 'color: green' : ''}`" @click="$router.push({ name: 'TaktingDescriptionOne'})"> What we do? </div>
        <!-- <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktTraining' ? 'color: #ff9300' : ''}`" @click="$router.push({ name: 'TaktTraining'})"> TAKT.app for training </div> -->
        <!-- <div class="home-detail-navigation-button" :style="`${$route.name === 'TaktTraining' ? 'color: green' : ''}`" @click="$router.push({ name: 'TaktTraining'}); toggleSidebar()"> Takt simulation </div> -->
        </div>
      </template>
      <template v-else-if="widget === 'research'">
        <div class="home-detail-button-list">
          <div class="home-detail-navigation-button" :style="`${$route.name === 'ResearchMain' ? 'color: green' : ''}`" @click="$router.push({ name: 'ResearchMain'})"> Research and Development</div>
          <div class="home-detail-navigation-button" :style="`${$route.name === 'ResearchInvestBW' ? 'color: green' : ''}`" @click="$router.push({ name: 'ResearchInvestBW'})"> Invest BW </div>
        </div>
      </template>
    </template>
    <template #content>
      <router-view/>
      <!-- {{current.content}} -->
    </template>
  </HomeDetail>
</template>

<script>
// import StandardDialogFullScreen from '@/components/StandardComponents/StandardDialogFullScreen.component.vue'
import HomeDetail from '@/components/Home/HomeDetail.component.vue'
import { mapActions } from 'vuex';
// import { HomeDetailToggler } from '@/components/Home/HomeDetail.component.vue'
export default {
  props: ['widget'],
  // mixins: [
  //   HomeDetailToggler,
  // ],
  components: {
    // StandardDialogFullScreen,
    HomeDetail
  },
  created(){
    this.setCurrent();
  },
  data: function() {
    return {
      update_key_careers: 0,
      current: {},
      widgets: {
        taktapp: {
          header: 'TAKT.app',
          content: 'The software for takt in construction'
        },
        takttraining: {
          header: this.$i18n.t('Home.Home.TaktTraining.Detail.Header'),
          content: this.$i18n.t('Home.Home.TaktTraining.Detail.Description')
        },
        algorithmicflow: {
          header: this.$i18n.t('Home.Home.AlgorithmicFlow.Detail.Header'),
          content: this.$i18n.t('Home.Home.AlgorithmicFlow.Detail.Description')
        },
        poweroftakt: {
          header: this.$i18n.t('Home.Home.PowerOfTakt.Detail.Header'),
          content: this.$i18n.t('Home.Home.PowerOfTakt.Detail.Description')
        },
        comingsoon: {
          header: this.$i18n.t('Home.Home.ComingSoon.Detail.Header'),
          content: this.$i18n.t('Home.Home.ComingSoon.Detail.Description')
        },
        homeworkbench: {
          header: this.$i18n.t('Home.Home.WorkBench.Detail.Header'),
          content: this.$i18n.t('Home.Home.WorkBench.Detail.Description')
        },
        taktpartners: {
          header: this.$i18n.t('Home.Home.TaktPartners.Detail.Header'),
          content: this.$i18n.t('Home.Home.TaktPartners.Detail.Description')
        },
        taktconnection: {
          header: this.$i18n.t('Home.Home.TaktConnect.Detail.Header'),
          content: this.$i18n.t('Home.Home.TaktConnect.Detail.Description')
        },
        taktcareer: {
          header: this.$i18n.t('Home.Home.TaktCareer.Detail.Header'),
          content: ''
        },
        takting: {
          header: "TAKT.ing",
          content: "The foundation for technological revolution in construction industry"
        },
        research: {
          header: "TAKT.ing Research",
          content: "TAKT.ing conducts ongoing research in many groundbreaking areas."
        }
      }
    }
  },
  methods: {
    ...mapActions('TaktNews', [
      'requestCareers',
    ]),
    setCurrent() {
      this.current = this.widgets[this.widget];
      let self = this;

      if (this.widget === 'taktcareer') {
        this.requestCareers().then(() => {
          self.update_key_careers++;
        });
      }

      
    },
    openNewTab(route) {
      window.open(route)
    }
  }
}
</script>

<style>
.home-detail-navigation-button {
  font-size: 20px;
 overflow: auto;
 cursor: pointer;
}
.home-detail-button-list {
  display: flex;
  flex-direction: column;
  gap:10px;
  text-align: right;
  /* align-items: flex-end; */
  padding: 10px;
  overflow-y: auto;
}
.home-detail-button-list > div {
  cursor: pointer;
}
.career-item {
  margin-top: 4px;
}
</style>
